import { parseBackendDate } from '@/lib/dates'
import type { Bolletta } from '@/lib/graphql/types'
import { cn } from '@/lib/utils'

/** Mappa stato → classi cromatiche per il chip grande del header. */
const STATE_CHIP: Record<string, string> = {
  pagata: 'bg-success/15 text-success',
  'in scadenza': 'bg-warning/20 text-warning-foreground',
  'da pagare': 'bg-secondary/15 text-secondary',
  scaduta: 'bg-destructive/12 text-destructive',
  rateizzata: 'bg-tertiary/20 text-tertiary-foreground',
  stornata: 'bg-muted text-muted-foreground',
}

function capitalize(s: string): string {
  return s ? s[0].toUpperCase() + s.slice(1) : s
}

function formatPeriodLong(invoice: Bolletta): string {
  const dal = parseBackendDate(invoice.dal)
  const al = parseBackendDate(invoice.al)
  if (dal && al) {
    const dalMese = capitalize(dal.format('MMMM'))
    const alMese = capitalize(al.format('MMMM'))
    const dalAnno = dal.format('YYYY')
    const alAnno = al.format('YYYY')
    if (dalMese === alMese && dalAnno === alAnno) return `${dalMese} ${alAnno}`
    if (dalAnno === alAnno) return `${dalMese} - ${alMese} ${alAnno}`
    return `${dalMese} ${dalAnno} - ${alMese} ${alAnno}`
  }
  return ''
}

export function InvoiceHeader({ invoice }: { invoice: Bolletta }) {
  const stato = (invoice.stato ?? '').toLowerCase()
  const chipColor = STATE_CHIP[stato] ?? 'bg-muted text-muted-foreground'
  const period = formatPeriodLong(invoice)

  return (
    <header className="flex flex-col items-center text-center">
      {period && <p className="text-sm text-muted-foreground">{period}</p>}
      <p className="mt-3 text-4xl font-bold text-secondary tabular-nums md:text-5xl">
        {Number(invoice.imponibile || 0).toFixed(2).replace('.', ',')} €
      </p>
      <span
        className={cn(
          'mt-3 inline-flex items-center rounded-full px-3 py-1 text-sm font-semibold capitalize',
          chipColor,
        )}
      >
        {invoice.stato || 'sconosciuto'}
      </span>
    </header>
  )
}
